export enum INSTANCE_UI {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=53170296
     */
    FAVORITES_NO_ENTRIES = 'FRONT.FAVORITES.NO_ENTRIES',
}

export enum INSTANCE_PICKER {
    SELECT_A_SITE = 'COMMUNITY_MOVE.SELECT',
}
